import type { Network } from '@vaultsfyi/common/types'

export const CHART_COLORS = {
  blue: 'var(--chart-blue)',
  violet: 'var(--chart-violet)',
  cyan: 'var(--chart-cyan)',
  yellow: 'var(--chart-yellow)',
  teal: 'var(--chart-teal)',
  orange: 'var(--chart-orange)',
  pink: 'var(--chart-pink)',
  fuchsia: 'var(--chart-fuchsia)',
  green: 'var(--chart-green)',
  red: 'var(--chart-red)',
}

export const NETWORK_COLORS: Record<Network, string> = {
  mainnet: 'rgb(98 126 234)',
  'mega-eth': 'rgb(223 217 217)',
  arbitrum: 'rgb(18 170 255)',
  avalanche: 'rgb(255 57 74)',
  base: 'rgb(0 82 255)',
  berachain: 'rgb(129 70 37)',
  bsc: 'rgb(240 185 11)',
  celo: 'rgb(252 255 82)',
  etherlink: 'rgb(56 255 156)',
  gnosis: 'rgb(19 54 41)',
  hyperliquid: 'rgb(151 252 228)',
  ink: 'rgb(113 50 245)',
  katana: 'rgb(246 255 13)',
  linea: 'rgb(97 223 255)',
  monad: 'rgb(110 84 255)',
  optimism: 'rgb(255 4 32)',
  plasma: 'rgb(22 47 41)',
  polygon: 'rgb(108 0 246)',
  robinhood: 'rgb(0 200 83)',
  swellchain: 'rgb(164 171 241)',
  unichain: 'rgb(252 15 164)',
  worldchain: 'rgb(89 88 88)',
}

export const ASSET_GROUP_COLORS: Record<string, string> = {
  ETH: 'rgb(98 126 234)',
  USD: 'rgb(39 117 202)',
  BTC: 'rgb(247 147 26)',
  EUR: 'rgb(0 114 255)',
  OTHER: 'rgb(128 128 128)',
}
